module.exports = __webpack_public_path__ + "img/P1_side_right2.2b15e259.png";